import Vue from "vue";
import Vuetify, { VSnackbar, VBtn, VIcon } from "vuetify/lib";

//import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#021e5c",
        secondary: "#2D7FF9",
        background: "#F7F7F8",
      },
      dark: {
        primary: "#021e5c",
        secondary: "#2D7FF9",
        background: "#0B0C15",
      },
    },
  },  
});
